import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "message" }

import { Button, Modal } from "@/components/ui";
import type { Variant } from "@/components/ui/types";

interface Props {
  show: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: Variant;
  isLoading?: boolean;
  zIndex?: number;
  dialogMaxWidth?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: "ActionConfirmationModal",
},
  __name: 'ActionConfirmationModal',
  props: {
    show: { type: Boolean },
    title: { default: "Are you sure?" },
    message: { default: "Please confirm this action." },
    confirmText: { default: "Confirm" },
    cancelText: { default: "Cancel" },
    confirmVariant: { default: "danger" },
    isLoading: { type: Boolean, default: false },
    zIndex: { default: 10080 },
    dialogMaxWidth: { default: "400px" }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {





const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    show: __props.show,
    title: __props.title,
    dialogMaxWidth: __props.dialogMaxWidth,
    closeOnBackdrop: false,
    zIndex: __props.zIndex,
    blurBackdrop: false,
    backdropOpacity: 0.3,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("small", _hoisted_2, _toDisplayString(__props.message), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(Button), {
        variant: "secondary",
        size: "md",
        block: "",
        disabled: __props.isLoading,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.cancelText), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(Button), {
        variant: __props.confirmVariant,
        size: "md",
        block: "",
        loading: __props.isLoading,
        disabled: __props.isLoading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.confirmText), 1)
        ]),
        _: 1
      }, 8, ["variant", "loading", "disabled"])
    ]),
    _: 1
  }, 8, ["show", "title", "dialogMaxWidth", "zIndex"]))
}
}

})